/**
 * Route for `device-breakdown-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DeviceBreakdownWidgetPage } from "../features/device-breakdown-widget/DeviceBreakdownWidgetPage";

export const deviceBreakdownWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/device-breakdown-widget",
	component: DeviceBreakdownWidgetPage,
});

export default deviceBreakdownWidgetRoute;
